import { render, staticRenderFns } from "./CreatePlatformDialog.vue?vue&type=template&id=7e361e1a&lang=pug&"
import script from "./CreatePlatformDialog.vue?vue&type=script&lang=ts&"
export * from "./CreatePlatformDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports